import React from 'react';
import './ArametPopup.css';
import PropTypes from 'prop-types';
import { paraigues, humidityBlack, vent_neutre } from '../../img';
import {             
    getNomDireccioVent,
    getRosaDelsVents 
} from '../../utils/utils';
import Loader from '../../partials/Loader/Loader';
import { translate } from '../../utils/translations';
import { Fragment } from 'react/cjs/react-jsx-runtime.production.min';



const ArametDoublePopup = props => {

    const { config, data, comarcaId } = props;

    let dataElements = [];
    let estCelIcon = []; 
    let iconImg = []; 
    let currentTemp = [];
    let currentPrec = [];
    let currentSimbolName = [];
    let currentVent = []; 
    let currentVentDir = [];
    let currentNomVentDir = [];
    let currentRosaVent = [];
    let nameElement = [];
    let currentHumitat = [];

    const unitatTemp = '°C';
    const unitatPluja = ' mm';
    const unitatVent = ' Km/h';
    const unitatHumitat = ' %';
    
    

    for(let i=0; i< data.est_cel.valor.length; i++ ){

        nameElement = data.name_elements.valor[i];
        estCelIcon = data.est_cel.valor[i];        
        currentSimbolName = data.est_cel_simbol.valor[i];
        
        if(estCelIcon === 's/d'){            
            iconImg = '';
        }else{             
            iconImg = estCelIcon;   
        }        

        currentTemp = data.current_temp.valor[i];       

        currentPrec = data.prec_acum.valor[i]; 

        if(currentPrec === -999999) currentPrec = 0;

        currentVent = data.current_vent.valor[i];
        
        currentVentDir = 's/d';

        currentNomVentDir = translate(props.config.language, 's_d');
        currentRosaVent = translate(props.config.language, 's_d');


        currentHumitat = data.current_hum.valor[i];


        if(data.vent_dir.valor[i] !== 's/d'){        

            currentVentDir = data.vent_dir.valor[i];
            currentNomVentDir = getNomDireccioVent(props.config.language, currentVentDir);
            currentRosaVent = getRosaDelsVents(props.config.language, currentVentDir);            
            
        }
    

        dataElements[i] = {
            nameElement,
            iconImg,
            currentSimbolName,
            currentTemp,
            currentPrec,
            currentVentDir,
            currentNomVentDir,
            currentRosaVent,            
            currentVent,
            currentHumitat            
        };

    }
        
    const multiplePopup = (dataElements.length >= 2); 
    
    
    

    if (!data) {
        return <Loader language={props.config.language} />;
    }

    return (

        <div className="popup-content">  
            <div className="flex-popup-content">
                {
                    dataElements.map( (element, index) => {

                        let classTemperatura = '';
                        const longitudTest = (element.currentNomVentDir+' ('+currentRosaVent+')').length;

                        if(longitudTest<= 13){
                            document.querySelector('.MapaAramet').style.setProperty('--width-popup', '130px'); 
                            classTemperatura = 'small';   
                        }else{
                            document.querySelector('.MapaAramet').style.setProperty('--width-popup', '150px');   
                        }

                        return(
                        <div key={element.nameElement} className={'item-content '+((index===0 && multiplePopup) ? 'first-content' : '')} style={{borderColor: config.color}}>

                            {/*multiplePopup && 
                                <div className='nom-municipi-aux'>{element.nameElement}</div>
                            */}
                            {comarcaId && <div className='nom-municipi-aux'>{element.nameElement}</div>}
                            <div className="flex-content" 
                                    style={{ 
                                            paddingTop: (multiplePopup ? '5px' : '0px'), 
                                            gap: (classTemperatura === '' ? '10px' : '5px' )
                                    }}
                            >                         
                                { (element.currentSimbolName === 's/d') ? <div></div> :                                
                                    <div className="first-column"> 
                                        <img alt={translate(config.language, 'estat_cel_'+currentSimbolName)} className={`mc-widget-aramet__icon aramet-icon-${element.currentSimbolName}`} src={element.iconImg}></img>
                                    </div>                                  
                                }                                     
                                <div className='second-column'>
                                    <div className={"mc-widget-aramet__temperatura "+classTemperatura}>
                                        {
                                            element.currentTemp === 's/d' ? 
                                            translate(config.language, 's_d')
                                            :
                                            <Fragment>
                                                {element.currentTemp}
                                                <sup className='mc-widget-aramet__temperatura-units'>&nbsp;{unitatTemp}</sup>
                                            </Fragment>
                                        }    
                                    </div> 
                                </div>                        
                            </div>
                            <div className='mc-widget-aramet-table-container'>
                                <div className='mc-widget-aramet-table-container-item'>
                                    <div className='mc-widget-aramet-table-container-item-icon' >
                                        <img src={humidityBlack} alt={translate(config.language, 'aramet_type_2')} style={{width: '19px'}} />
                                    </div>
                                    <div className='mc-widget-aramet-table-container-item-units humidity'>
                                        {element.currentHumitat === 's/d' ? translate(config.language, 's_d') : element.currentHumitat+unitatHumitat} 
                                    </div>
                                </div>
                                <div className='mc-widget-aramet-table-container-item'>
                                    <div className='mc-widget-aramet-table-container-item-icon' >
                                        <img src={paraigues} alt={translate(config.language, 'aramet_type_1')} />
                                    </div>
                                    <div className='mc-widget-aramet-table-container-item-units'>
                                        {element.currentPrec === 's/d' ? translate(config.language, 's_d') : element.currentPrec+unitatPluja} 
                                    </div>
                                </div>
                                
                                <div className='mc-widget-aramet-table-container-item'>
                                    <div className='mc-widget-aramet-table-container-item-icon' >

                                        { element.currentVentDir === 's/d' ? 
                                            <img src={vent_neutre} alt={translate(config.language, 'titol_vent')} />
                                            :
                                            <svg
                                                x="0px"
                                                y="0px"
                                                width="20px"
                                                height="20px"
                                                viewBox="-37.794 -27.92 100 100"
                                                enableBackground="new -37.794 -27.92 100 100"
                                                style={{
                                                    WebkitTransform: `translate(-1px, 0px) rotate(${element.currentVentDir}deg) scale(1.2)`,
                                                    transform: `translate(-1px, 0px) rotate(${element.currentVentDir}deg) scale(1.2)`,
                                                    transformOrigin: `10px 10px`,
                                                    WebkitTransformOrigin: `10px 10px`,
                                                }}
                                                >
                                                    <g>
                                                        <line
                                                            fill="none"     
                                                            stroke="#000000"                     
                                                            strokeWidth="6"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="bevel"
                                                            x1="12.206"
                                                            y1="3"
                                                            x2="12.206"
                                                            y2="41.16"
                                                        />
                                                        <polygon
                                                            fill="#000000" 
                                                            points="0,27.252 12.206,39.466 24.419,27.252 24.419,37.613 12.206,49.822 0,37.613 		"
                                                        />
                                                    </g>
                                                </svg>
                                        }

                                    </div>
                                    <div className='mc-widget-aramet-table-container-item-units'>                                        
                                        <div>{element.currentVent === 's/d' ? translate(config.language, 's_d') :  element.currentVent+unitatVent}</div>
                                        <div className='mc-widget-aramet-wind-name'>{element.currentNomVentDir} ({currentRosaVent})</div>
                                    </div>
                                </div>

                                

                            </div>
                            
                            
                            
                        </div>
                        );

                    })
                }               

            </div>
        </div>
    );
};

ArametDoublePopup.propTypes = {
    config: PropTypes.shape({
        alternativeTitle: PropTypes.string,
        color: PropTypes.string,
        language: PropTypes.string,
        location: PropTypes.string,
        type: PropTypes.string,
        variables: PropTypes.arrayOf(PropTypes.string),
    }),
    data: PropTypes.object
};

export default ArametDoublePopup;



// WEBPACK FOOTER //
// ./src/partials/ArametPopup/ArametDoublePopup.js